import { getHierarchyOpts } from "actions/CarrierAgreementMgmt/Hierarchy";
import { useQuery } from "react-query";

export const useGetHierarchyOpts = () => {
  return useQuery("GetHierarchyOpts", getHierarchyOpts, {
    refetchOnWindowFocus: false,
  });
};
